import jquery from 'jquery';
import wwdev from '@wwdev/functions';
import * as bootstrap from 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;
window.wwdev = wwdev;
window.bootstrap = bootstrap;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
$('.button-prevent-multiple-submit').addClass('btn-primary');
$.fn.serializeObject = function() {
	let form = this[0];
	let formdata = new FormData(form);
	let object = {};
	for(let item of formdata) {
		object = Object.assign({[item[0]] : item[1]}, object);
	}
	return object;
}